import React, { useState } from 'react';
import { Row, Col, Button, Form, Dropdown, ButtonGroup, Modal, Pagination } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaMoneyBillAlt, FaEdit } from "react-icons/fa";
import { MdOutlineAdd } from "react-icons/md";
import { IoEye } from "react-icons/io5";
import { RiDeleteBin5Line } from "react-icons/ri";

import './accounts.css';
import AccountLayout from '../../components/AccountLayout.jsx';

// Dummy data for demonstration
const dummyData = Array.from({ length: 30 }, (_, index) => ({
  sr: index + 1,
  name: `Account ${index + 1}`,
  category: index % 2 === 0 ? 'Purchase' : 'Sale',
}));

export default function Accounts() {
  const [show, setShow] = useState(false);
  const [modalData, setModalData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const handleShow = (data) => {
    setModalData(data);
    setShow(true);
  };

  const handleClose = () => setShow(false);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(dummyData.length / rowsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };

  // Calculate page range
  const pageRange = () => {
    const pages = [];
    const totalPages = Math.ceil(dummyData.length / rowsPerPage);
    let startPage = Math.max(currentPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);

    if (endPage - startPage < 2) {
      startPage = Math.max(endPage - 2, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  const displayedData = dummyData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  return (
    <AccountLayout>
      <div >
        <h1 style={{ color: '#0353a4', textAlign: 'left', fontSize: '2rem',marginTop:'10px' }}>
          <FaMoneyBillAlt />
          Account
        </h1>
        <hr className="custom-accounts-divider" />
        <div className='custom-accounts-content'>
          <Link to="/add-account">
            <Button variant='primary' className='custom-apply-leave-button'>
              <MdOutlineAdd className="custom-button-icon" /> Add Account
            </Button>
          </Link>
          <div className='custom-accounts-actions'>
            <Row>
              <Col xs={12} md={6} className="d-flex align-items-center mb-2">
                <Dropdown as={ButtonGroup}>
                  <Button variant="primary">Show Entries</Button>
                  <Dropdown.Toggle split variant="primary" id="dropdown-split-basic" />
                  <Dropdown.Menu>
                    <Dropdown.Item href="#/action-1">10</Dropdown.Item>
                    <Dropdown.Item href="#/action-2">25</Dropdown.Item>
                    <Dropdown.Item href="#/action-3">50</Dropdown.Item>
                    <Dropdown.Item href="#/action-4">100</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
              <Col xs={12} md={6} className="d-flex justify-content-end mb-2">
                <div className='custom-search-container'>
                  <Form className="d-flex">
                    <Form.Control
                      type="search"
                      placeholder="Search"
                      aria-label="Search"
                      className="custom-total-leave-search"
                    />
                  </Form>
                </div>
              </Col>
            </Row>
          </div>
          <div className="custom-table-container">
            <table className='table table-striped custom-table-style'>
              <thead className="custom-accounts-table-header">
                <tr className="custom-table-header">
                  <th>SR</th>
                  <th>Account Name</th>
                  <th>Category</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {displayedData.map((item) => (
                  <tr key={item.sr} style={{ textAlign: 'center' }}>
                    <td>{item.sr}</td>
                    <td>{item.name}</td>
                    <td>{item.category}</td>
                    <td>
                      <div className='custom-action-buttons'>
                        <Button className='btn btn-primary' onClick={() => handleShow(item)}>
                          <IoEye />
                        </Button>
                        <Link to='/edit-account'>
                          <Button className='custom-edit-button'><FaEdit /></Button>
                        </Link>
                        <Button className='btn btn-danger'><RiDeleteBin5Line /></Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot className='table-footer'>
                <tr className='accounts-table-footer'>
                  <td colSpan="4" style={{ textAlign: 'left' }}>
                    Showing {(currentPage - 1) * rowsPerPage + 1} to {Math.min(currentPage * rowsPerPage, dummyData.length)} of {dummyData.length} entries
                  </td>
                </tr>
              </tfoot>
            </table>
            <div className="custom-pagination-container">
              <Row className="custom-row">
                <Col xs={12} md={9} className="custom-col-left">
                  Showing {(currentPage - 1) * rowsPerPage + 1} to {Math.min(currentPage * rowsPerPage, dummyData.length)} of {dummyData.length} entries
                </Col>
                <Col xs={12} md={3} className="custom-col-right">
                  <Pagination>
                    <Pagination.Prev
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      Previous
                    </Pagination.Prev>
                    {pageRange().map(page => (
                      <Pagination.Item
                        key={page}
                        active={page === currentPage}
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </Pagination.Item>
                    ))}
                    <Pagination.Next
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === Math.ceil(dummyData.length / rowsPerPage)}
                    >
                      Next
                    </Pagination.Next>
                  </Pagination>
                </Col>
              </Row>
            </div>
          </div>
        </div>

        {/* Modal for displaying account details */}
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Account Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p><strong>Account Name:</strong> {modalData.name}</p>
            <p><strong>Category:</strong> {modalData.category}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </AccountLayout>
  );
}
